export enum CurveType {
  'CENTRIPETAL' = 'centripetal',
  'CHORDAL' = 'chordal',
  'CATMULLROM' = 'catmullrom',
}
